import React, { Component } from 'react';
import Gamescene from './Gamescene';
import Landing from './components/Landing';
import Assets from './components/Assets';
import CrawlText from './components/CrawlText';
import Camera from './components/Camera';
import GlobalEvents from './utils/global-events';
import ReactGrid from './scenes/ReactGrid.js';
import InfinityGauntlet from "react-thanos-snap";
import * as simulationSocket from './APIs/simulationSocket';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import './css/Landing.css';



import CenteredTabs from './components/TabBar';


const tabContent = ["Conceptual Model", "Architecture"];

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

function randomString(length, chars) {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}

let clientdata = null
const config = require('./utils/config')

class App extends Component {
    constructor() {
        super();
        this.action = (key) => (

            <IconButton onClick={() => { this.props.closeSnackbar(key) }}>
                <CloseIcon />
            </IconButton>

        );
        this.state = {
            namespace: "simulation",
            showAnimation: true,
            landingPage: false,
            redirect: false,
            snap: false,
            id: 'helloworld',
            countryName: 'usa',
            showLogoutbutton: false,
            showCountry: false,
            phs1trigger: true,
            crawlTextTrigger: false,
            crawlDoneFlag: true,
            time_data: [],
            activity_data: [],
            drinking_moment: [],
            beverage_category: [],
            beverage_category_by_drinking: [],
            drinking_moment_by_beverage: [],
            noOfTicks: 25,
            noOfAgents: 50,
            isPrimary: true,
            infoClicked: false,
            tab: 1,
            imageSource: "maslows_new8.png",
            simStarted: false,
            simCompleted: false,
            showUserDialog: false,
            showSimEndInfo: false,
            showStartDialog: false,
            socketStatus: false,
            dialogOptions: {
                noOfUsers: 0,
                userForcing: "",
                forcedToExit: false
            },
            graphdata: { 'name': 'Units Sold', data: [] },
            simSummary: {
                "graph": {
                    "Competitor1": 10,
                    "Competitor2": 50,
                    "Your Brand": 6
                },
                "ticks": 150,
                "agents": 200,
                "profit": 20,
                "product": {
                    "pricing": {
                        "ctc": 2,
                        "profit_margin": 60
                    },
                    "specs": {
                        "health": 4,
                        "taste": 5,
                        "pleasure": 3
                    }
                },
                "beverage_cat": "tea"
            }
        };
        sessionStorage.clear();
        sessionStorage.setItem("tab", (this.state.tab === 0 ? "admin" : "marketing"));
    }

    openEgg = (e) => {
        GlobalEvents.trigger('changeEgg');
    }

    showLogout = (e) => {
        this.setState({
            showLogoutbutton: !this.state.showLogoutbutton
        })
    }

    Logout = (e) => {

        GlobalEvents.trigger('logout');


        this.setState(({
            snap: !this.state.snap
        }))
        setTimeout(() => {
            GlobalEvents.trigger('logout');

            window.location.reload();
        }, 12000)


    }

    countryTrigger(data) {

        const splitData = data.split("-");
        const country = splitData[0];
        const namespace = splitData[1];

        if (country === 'usa') {

            let flag = this.state.landingPage;

            this.setState({
                showAnimation: false,
                countryName: country,
                landingPage: !flag,
                crawlDoneFlag: true,
                showCountry: flag,
                showglobe: false,
                namespace: namespace
            })

        }
        else {
            alert("Map development is in progress, Wait till next build for country - ".concat(country.toUpperCase()))
        }
    }

    CrawlTrigger() {
        this.setState({
            crawlTextTrigger: true
        })
    }


    handleSimulationSocket() {
        const self = this;
        sessionStorage.setItem('ClientId', randomString((Math.floor(Math.random() * 7) + 5), '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'))
        console.log('Simualation socket connected');
        simulationSocket.subscribeToNamespace('connection-properties', (data) => {
            clientdata = data;
            console.log('simulation start status', data);
            if (data.noOfUsers > 0) {
                self.setState({
                    isPrimary: data.isPrimary,
                    showUserDialog: true,
                    dialogOptions: {
                        noOfUsers: data.noOfUsers,
                        userForcing: "",
                        forcedToExit: false
                    },
                    socketStatus: true,
                });
            } else {
                this.setState({
                    showStartDialog: true,
                    socketStatus: true,
                })
            }
        });
        simulationSocket.subscribeToNamespace('simulation_status', (data) => {
            // Promotion sessionStorage spends update fn
            this.updatePromotionNumbers();
        });
        simulationSocket.subscribeToNamespace('closeSession', self.gotKicked);
    }

    kickOthers = () => {
        const self = this;
        self.showNotification("Closing all other user sessions. Please wait.");
        simulationSocket.emitData("kick_others", { userName: this.splitWord(config.username) });
        self.setState({
            showUserDialog: false,
            showStartDialog: true
        });
    }


    calcPos = () => {
        // const self = this;
        let result = 0
        //    let keys = Object.keys(this.state.simSummary['graph'])
        let values = Object.values(this.state.simSummary['graph'])
        values = values.sort(function (a, b) {
            return b - a;
        })
        for (var j = 0; j < values.length; j++) {
            if (this.state.simSummary['graph']['Your Brand'] === values[j]) {
                result = j
            }
        }

        return result + 1
    }


    closeDialog = () => {
        document.querySelector('#startsimul').click()
        const self = this;
        self.setState({
            showUserDialog: false,
            showStartDialog: true
        });
    }

    closeStartDialog = () => {
        const self = this;
        self.setState({
            showStartDialog: false
        })
    }
    gotKicked = (data) => {
        const self = this;
        if (data.userName.toLowerCase() !== this.splitWord(config.username)) {
            self.setState({
                showUserDialog: true,
                dialogOptions: {
                    userForcing: data.userName,
                    forcedToExit: true
                }
            });
            setTimeout(() => {
                self.exitGame();
            }, 5000);
        } else {
            self.showNotification("Closed all user sessions. Please refresh to continue.", { variant: "success" });
            self.setState({
                showUserDialog: false
            });
        }
    }
    exitGame = () => {
        const self = this;
        self.showNotification("Exiting Game", { variant: "warning" });
        self.setState({
            showUserDialog: false
        });
        window.location.reload();
        // oauth2Context.logout();
    }

    showglobe() {
        this.setState({
            showCountry: false,
            phs1trigger: false
        })
    }

    componentDidMount() {
        const self = this;
        GlobalEvents.on('triggerOpenScenarioSimulation', this.triggerSimulation.bind(this))
        GlobalEvents.on('showglobe', this.showglobe.bind(this))
        GlobalEvents.on('triggercountry', this.countryTrigger.bind(this));
        // GlobalEvents.on('cityloaded', this.CrawlTrigger.bind(this));
        GlobalEvents.on('CrawlComplete', () => {
            this.setState({ crawlDoneFlag: true })
        });
        GlobalEvents.on('Agentsdata', (data) => {
            this.setState({
                noOfAgents: data
            })
        })
        GlobalEvents.on('Ticksdata', (data) => {
            this.setState({
                noOfTicks: data
            })
        })

        GlobalEvents.on("gotohome", () => {
            this.setState({
                simCompleted: false,
                simStarted: false
            })
        })

        GlobalEvents.on('startsim', (data) => {

            if (self.state.simStarted === true && self.state.simCompleted === true) {
                this.showNotification("Please refresh the page to start simulation again.", { variant: "warning" });
                this.setState({
                    showSimEndInfo: true
                })
                // setTimeout(() => {
                //     self.exitGame();
                // }, 5000);
                return;
            } else if (self.state.simStarted === true && self.state.simCompleted !== true) {
                this.showNotification("Functionality to stop simulation is not available yet.", { variant: "warning" });
                return;
            }
            if (!clientdata.isPrimary) {
                this.showNotification('You are logged in as spectator', { variant: "warning" })
            } else {
                this.showNotification("Starting Simulation")
            }
            sessionStorage.setItem("simStarted", "true");
            sessionStorage.setItem("simCompleted", "false");

            simulationSocket.subscribeToNamespace('simMetadata', (data) => {
                if (data.simCompleted) {
                    this.showNotification("Simulation Completed", { variant: "success" })
                    sessionStorage.setItem("simCompleted", "true");
                    GlobalEvents.trigger('showendinfo')

                } else if (data.simStarted) {
                    this.showNotification("Simulation Started", { variant: "success" })
                }

            })

            this.triggerSimulation();

            if (this.state.simStarted === false) {
                this.setState({ simStarted: true });
            }

        });

        GlobalEvents.on('connect_socket', (namespace) => {
            sessionStorage.setItem("namespace", namespace);
            simulationSocket.connectSocket(this.handleSimulationSocket.bind(this), null, namespace);
        })

    }

    updatePromotionNumbers = () => {
        if (sessionStorage.getItem('cur_burn_rate')) {
            let current_spends = parseFloat(sessionStorage.getItem('cur_spends'));
            let cur_burn_rate = parseFloat(sessionStorage.getItem('cur_burn_rate'));
            let current_tick_spends = cur_burn_rate / (24 * 7);
            current_spends += current_tick_spends;
            current_spends = current_spends.toFixed(2);
            sessionStorage.setItem('cur_spends', parseFloat(current_spends));
        }
    };

    triggerSimulation = () => {
        simulationSocket.startSimualation({ "scenarioId": config.scenarioId }, this.state.namespace);
        if (this.state.namespace === "openScenario") {
            sessionStorage.setItem("simStarted", "true");
            sessionStorage.setItem("simCompleted", "true");
            this.setState({ simStarted: true })
        }
    }

    showNotification = (msg, options = {}) => {
        const self = this;
        this.props.enqueueSnackbar(msg, Object.assign(
            {
                key: msg,
                action: self.action,
                variant: 'info',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                    autoHideDuration: 1000,
                    preventDuplicate: true
                }
            }, options));
    }
    handleCloseSimEndInfo = () => {
        this.setState({
            showSimEndInfo: false
        })
    }

    skipTutorial() {
        var phase2event = new CustomEvent('phase2trigger');

        this.showNotification("Skipping Tutorial");

        setTimeout(() => {

            document.body.dispatchEvent(phase2event);
        }, 100)
        setTimeout(() => {
            GlobalEvents.trigger('CrawlComplete');
        }, 200)
        clearInterval(window.cam_interval);
    }

    splitWord(username) {
        return username.replace(".", " ")
    }

    resetGlobe() {
        let rot = document.querySelector('#globeB').getAttribute('rotation')
        rot.x = 36.5;
        rot.y = 4.5;
        rot.z = 0;
        document.querySelector('#globeB').setAttribute('rotation', rot)
    }

    changeTab = (e, v) => {
        // console.log('tab selected', v)
        GlobalEvents.trigger('tab_selected', v)

        setTimeout(() => {
            if (this.state.simStarted) {
                this.state.tab === 0 ? GlobalEvents.trigger('environmentWidget', 'graphs') : GlobalEvents.trigger('changeWidget', 'graphs2');
            }
        }, 5);
        this.setState({ tab: v });

    }

    onInfoClick = () => {
        this.setState({
            infoClicked: !this.state.infoClicked
        })
    }

    onTabClick = (event, value) => {
        if (value === 0) {
            this.setState(
                {
                    imageSource: "maslows_new8.png"
                }
            )
        }
        if (value === 1) {
            this.setState(
                {
                    imageSource: "real_games_arch.png"
                }
            )
        }
    }

    render() {

        return (
            <div id="Golden">
                <InfinityGauntlet snap={this.state.snap}>
                    <div className="flex-container" style={{ backgroundColor: this.state.showCountry || this.state.landingPage ? '#344955' : '#34495500' }}>
                        <img onClick={this.openEgg.bind(this)} alt="GameLogo" src="finalLogo.png" style={{ width: "10%", alignSelf: 'flex-end', marginBottom: '1vh' }} />
                        <div className="versionNumber" style={{ alignSelf: 'flex-end', marginBottom: '1vh' }}>|v19.10.03</div>

                        <div style={{
                            marginLeft: "auto",
                            alignSelf: 'auto',
                            marginTop: '1%',
                            marginRight: '4%'
                        }}></div>
                        <div className="tooltip" style={!this.state.showCountry ? { marginLeft: 'auto' } : null}>
                            <img onClick={this.onInfoClick} alt="info_icon" id="info_icon" src="info_new.svg" style={{ width: '1.4vw', cursor: "pointer" }}></img>
                            <div class={this.state.infoClicked ? "bottomPersist" : "bottom"}>
                                <div class="TabsBar">
                                    <CenteredTabs action={this.onTabClick} tabContent={tabContent} default={0} />
                                    <Button onClick={this.onInfoClick} ><CloseIcon style={{ color: "black" }} /></Button>
                                </div>

                                <img className="infoImage" alt={this.state.imageSource === "maslows_new8.png" ? "maslow" : "games architechure"} src={this.state.imageSource}
                                    style={{ background: 'transparent' }}></img>

                            </div>
                        </div>
                        <div style={{ backgroundColor: "#D2DBE0" }} className="name" onClick={this.showLogout}>
                            <div style={{ border: '2px solid var(--secondary-color)' }} className="circle">
                                <img style={{ width: '1.6vw', height: '1.75vw' }} className="userphoto"
                                    src={`https://eoc.mu-sigma.com/phoenix/oauth-service/user/image/${config.username}?${new Date()}`}
                                    alt="Avatar"></img>
                            </div>
                            <p style={{ color: 'var(--secondary-color)' }}
                                className="username">{this.splitWord(config.username)}</p>
                        </div>


                        <br />
                        <div className="logout" style={{
                            width: this.state.showLogoutbutton ? 'auto' : '0%',
                            display: this.state.showLogoutbutton ? 'block' : 'none',
                            margin: 0,
                            fontSize: '1vw',

                        }} onClick={this.Logout}>
                            <img src="logout.svg" width="15vw" height="15vw" alt="logout"></img>Logout
                    </div>

                    </div>

                    {this.state.landingPage ? <Landing showNotification={this.showNotification} /> : null}

                    {this.state.showCountry && !this.state.landingPage ? simulationSocket.connectSocket(this.handleSimulationSocket.bind(this), null, this.state.namespace) : null}

                    {this.state.crawlTextTrigger && !this.state.crawlDoneFlag ?
                        <img className='skipicon' id="skipicon" alt="skipicon" src="skip.svg"
                            onClick={this.skipTutorial.bind(this)} /> : null}

                    {this.state.crawlTextTrigger && !this.state.crawlDoneFlag ? <CrawlText /> : null}

                    {this.state.showCountry ?
                        <ReactGrid
                            // key={`${new Date()}`}
                            countryname={this.state.countryName}
                            height={config[this.state.countryName].height}
                            width={config[this.state.countryName].width}
                            latitude={config[this.state.countryName].latitude}
                            longitude={config[this.state.countryName].longitude}
                            zoom={config[this.state.countryName].zoom}
                            pitch={config[this.state.countryName].pitch}
                            maxZoom={config[this.state.countryName].maxZoom}
                            mapboxApiAccessToken={config[this.state.countryName].mapboxApiAccessToken}
                            mapStyle={config[this.state.countryName].mapStyle}
                            geourl={config[this.state.countryName].geourl}
                            subscribe_ns={simulationSocket.subscribeToNamespace}
                            unsubscribe_ns={simulationSocket.unsubscribeToNamespace}
                            emit_data={simulationSocket.emitZipData}
                            showNotification={this.showNotification}
                            simStarted={this.state.simStarted}
                            simCompleted={this.state.simCompleted}
                            namespace={this.state.namespace}
                            disconnectSocket={simulationSocket.disconnectSocket}
                        /> : null}

                    {!this.state.showCountry && this.state.crawlDoneFlag && !this.state.landingPage ?
                        <img alt="reset" src="resetr.svg" onClick={this.resetGlobe.bind(this)} id="resetr"></img> : null}

                </InfinityGauntlet>

                {!this.state.landingPage && this.state.showAnimation ?
                    <a-scene id="gamescene" light="defaultLightsEnabled: false"
                        loading-screen="dotsColor: gold; backgroundColor: black"
                        vr-mode-ui="enabled: false" /*gltf-model={{dracoDecoderPath: "/Draco/"}}*/
                        color-space="sRGB" background="color: skyblue">
                        <Assets />
                        <Camera />
                        <a-entity id="light2" position="0 3 0.7"
                            light="type: directional; castShadow: true; intensity: 0.5; shadowCameraFov: 90; angle: 0;"></a-entity>
                        <a-entity id="light1"
                            light="color: #BBB; shadowCameraFov: 90; type: ambient; angle: 60; "></a-entity>
                        <Gamescene phs1trigger={this.state.phs1trigger} />
                    </a-scene> : null}

                <Dialog
                    open={this.state.showUserDialog}
                    TransitionComponent={Transition}
                    keepMounted
                    disableBackdropClick
                    disableEscapeKeyDown
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description" style={{ width: "100% !important" }}
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        {"What would you like to do?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            {
                                "Only 1 user can use the game at any given time but there are " + this.state.dialogOptions.noOfUsers + " other users using the game. " +
                                "What would you like to do?"
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.exitGame} color="primary">
                            Exit
                        </Button>
                        <Button onClick={this.closeDialog} color="primary">
                            Continue as Spectator
                        </Button>
                        <Button onClick={this.kickOthers} color="primary">
                            Close all other sessions
                        </Button>
                    </DialogActions>
                </Dialog>

                {
                    (this.state.dialogOptions.forcedToExit === true ?
                        <Dialog
                            open={this.state.showUserDialog}
                            TransitionComponent={Transition}
                            keepMounted
                            disableBackdropClick
                            disableEscapeKeyDown
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description" style={{ width: "100% !important" }}
                        >
                            <DialogTitle id="alert-dialog-slide-title">
                                {"The game will exit"}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                    {
                                        "The user " + this.state.dialogOptions.userForcing + " has requested all users to close their sessions. " +
                                        "The game will exit in 5 seconds."
                                    }
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.exitGame} color="primary">
                                    Exit
                                </Button>
                            </DialogActions>
                        </Dialog>
                        :
                        null)
                }
            </div>
        );
    }
}
export default App;
